var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"custom-mobile-button",on:{"click":_vm.back}},[_vm._v("\n  "+_vm._s(_vm.$t("Confirmation.Cancel"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }